import { Navigate, useSearchParams } from "react-router";
import type { RouteConfig } from "@/router/types";

type RedirectConfig = {
  from: string
  to: string
  preserveSearch?: boolean
};

const REDIRECTS: RedirectConfig[] = [
  // Legacy yeati-boutique redirects
  { from: "/mon-compte/echanges", to: "/discussions" },

  // User profile & account
  { from: "/mon-compte/mes-cartes", to: "/ma-carte" },
  { from: "/mon-compte/mes-coordonnees", to: "/mon-profil" },
  {
    from: "/mon-compte/mes-coordonnees/ayant-droits/index",
    to: "/mon-profil?tab=beneficiaries",
  },

  // Auth
  { from: "/connect", to: "/connexion" },
  { from: "/co", to: "/connexion" },
  { from: "/2fa", to: "/connexion" },

  // Landing pages
  { from: "/landing", to: "/" },
  { from: "/landing-v2", to: "/" },

  // Features renamed
  { from: "/subvention-display", to: "/subventions" },
  { from: "/remboursement/index", to: "/remboursements" },
  { from: "/documents/index", to: "/fichiers" },
  { from: "/cart-v2", to: "/boutique/panier" },

  // Boutique malformed subcategories
  { from: "/boutique/parcs-loisirs/cinema", to: "/boutique/cinema" },
  { from: "/boutique/parcs-loisirs/parcs-loisirs", to: "/boutique/parcs-loisirs" },
  { from: "/boutique/cadeaux/cadeaux", to: "/boutique/cadeaux" },

  // Other legacy routes
  { from: "/representatives", to: "/trombinoscope" },
];

const RedirectWithSearch = ({ to }: { to: string }) => {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const destination = search ? `${to}?${search}` : to;
  return <Navigate to={destination} replace />;
};
RedirectWithSearch.displayName = "RedirectWithSearch";

const createRedirectElement = (to: string, preserveSearch?: boolean) => {
  if (preserveSearch) {
    return <RedirectWithSearch to={to} />;
  }
  return <Navigate to={to} replace />;
};

export const redirectRoutes: RouteConfig[] = REDIRECTS.map(({ from, to, preserveSearch }) => ({
  path: from,
  element: createRedirectElement(to, preserveSearch),
  isProtected: false,
  useMainLayout: false,
}));
